import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
export var ShowContent = function (_a) {
    var children = _a.children, _b = _a.show, show = _b === void 0 ? true : _b;
    useEffect(function () {
    }, [show]);
    return (_jsx(_Fragment, { children: show ?
            (_jsx(_Fragment, { children: children })) : null }));
};
